import type { CityConfig } from "../city-template/types";

export const hollySpringsConfig: CityConfig = {
  vitalRecordsIcon: "ri-file-text-line",
  city: "Holly Springs",
  state: "North Carolina",
  stateAbbr: "NC",
  slug: "holly-springs",
  route: "/holly-springs",
  title: "Emergency Passport Holly Springs, NC — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Holly Springs, NC — as fast as 24 hours. Same-day courier processing available. A+ BBB rated, registered State Dept. courier serving Wake County and southern Research Triangle. Get your passport fast!",
  h1: "Emergency & Expedited Passport Services in Holly Springs, NC",
  heroSubtitle: "Passport expired before your trip? Need an emergency passport fast? We help Holly Springs and southern Wake County travelers get their expedited passports as quickly as 24 hours. A+ BBB rated. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Holly%20Springs%20North%20Carolina%20scenic%20suburban%20landscape%20at%20golden%20hour%20with%20modern%20residential%20neighborhoods%2C%20green%20parks%20and%20rolling%20hills%20of%20Wake%20County%2C%20southern%20Research%20Triangle%20community%20atmosphere%2C%20warm%20sunset%20light%20over%20well-maintained%20suburban%20streets%20with%20mature%20trees%2C%20clean%20modern%20American%20suburb%20with%20family%20homes%2C%20professional%20landscape%20photography%20with%20warm%20earthy%20tones%20and%20southern%20growth%20atmosphere%2C%20no%20text%20or%20signs%20on%20buildings&width=1800&height=700&seq=holly-springs-hero-nc-001&orientation=landscape",
  heroImageAlt: "Holly Springs North Carolina suburban landscape with green parks and rolling hills at golden hour",
  geoPosition: "35.6513;-78.8336",
  geoPlacename: "Holly Springs, North Carolina",
  lastModified: "2026-07-21",
  regionalAgency: {
    name: "Washington DC Passport Agency",
    address: "600 19th St NW, Washington, DC 20006",
    distance: "Approximately 280 miles north — about 4.5 hours via I-95",
  },
  nearbyCitiesZips: [
    { name: "Holly Springs", zips: "27540" },
    { name: "Apex", zips: "27502, 27523, 27539" },
    { name: "Cary", zips: "27511, 27513, 27518, 27519" },
    { name: "Fuquay-Varina", zips: "27526" },
    { name: "Raleigh", zips: "27601–27699" },
    { name: "Durham", zips: "27701–27717" },
    { name: "Morrisville", zips: "27560" },
    { name: "Chapel Hill", zips: "27514, 27516, 27517" },
    { name: "Garner", zips: "27529" },
    { name: "Wake Forest", zips: "27587, 27588" },
    { name: "Knightdale", zips: "27545" },
    { name: "Zebulon", zips: "27597" },
    { name: "Wendell", zips: "27591" },
    { name: "Angier", zips: "27501" },
    { name: "Clayton", zips: "27520, 27527" },
    { name: "Smithfield", zips: "27577" },
    { name: "Lillington", zips: "27546" },
    { name: "Sanford", zips: "27330, 27332" },
    { name: "Fayetteville", zips: "28301–28312" },
    { name: "Wilson", zips: "27893, 27894, 27895, 27896" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier submission for urgent Wake County departures" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-user-line", title: "Dedicated Agent", desc: "A real person assigned to your case from start to finish" },
    { icon: "ri-map-pin-2-line", title: "Southern Wake Hub", desc: "Serving Holly Springs, Fuquay-Varina, Apex, and southern Research Triangle" },
  ],
  internalLinks: [
    { name: "Expedited passport services in Raleigh, NC", route: "/raleigh" },
    { name: "Fast passport renewal in Cary, NC", route: "/cary" },
    { name: "Emergency passport help in Apex, NC", route: "/apex" },
    { name: "Urgent passport services in Durham, NC", route: "/durham" },
    { name: "Same-day passport help in Wake Forest, NC", route: "/wake-forest" },
    { name: "Passport courier services in Fayetteville, NC", route: "/fayetteville" },
    { name: "Passport courier services in Fuquay-Varina, NC", route: "/fuquay-varina" },
    { name: "Emergency passport help in Morrisville, NC", route: "/morrisville" },
    { name: "Passport courier services in Garner, NC", route: "/garner" },
    { name: "Emergency passport help in Clayton, NC", route: "/clayton" },
    { name: "Passport courier services in Sanford, NC", route: "/sanford" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Holly Springs remotely via secure courier. We do not have a walk-in office in Holly Springs — our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities. This is how we achieve 24–48 hour turnaround for Wake County and the southern Research Triangle travelers.",
  fpcOfficeAddress: "301 Fayetteville St, Raleigh, NC 27601",
  mapEmbedUrl: "https://www.google.com/maps?q=301+Fayetteville+St,+Raleigh,+NC+27601&output=embed",
  fpcOfficeDistance: "Serving all of Wake County and the southern Research Triangle metropolitan region",
  serviceAreaIntro: "From the family-friendly neighborhoods of Holly Springs to the growing communities of Fuquay-Varina, from the historic charm of Apex to the bustling corridors of Cary and Morrisville, from the university hubs of Raleigh and Durham to the quiet streets of Garner and Clayton, from the military families of Fayetteville to the southern roads of Angier and Lillington — Fast Passport Center serves the entire Holly Springs region. We regularly help travelers from the Research Triangle, southern Wake County, and Johnston County get their passports fast.",
  nearbyCitiesIntro: "We serve all Holly Springs neighborhoods and the surrounding southern Research Triangle area including Apex, Cary, Fuquay-Varina, Raleigh, Durham, Morrisville, Chapel Hill, Garner, Wake Forest, Knightdale, Zebulon, Wendell, Angier, Clayton, Smithfield, Lillington, Sanford, Fayetteville, and Wilson. If you are anywhere in Wake County, Johnston County, or the southern Research Triangle, we have you covered.",
  howItWorksIntro: "Most Holly Springs travelers complete everything online and ship documents overnight. No need to drive to Washington DC or wait in line at the regional agency.",
  mistakesIntro: "Holly Springs travelers often face long drives to the nearest regional passport agency. Here are the most common mistakes that cause delays.",
  testimonialsIntro: "Holly Springs and southern Wake County travelers trust us when their departure is days away. Here is what some of them have to say.",
  faqIntro: "Have questions about expedited passports in Holly Springs? Here are the most common ones we hear from Wake County travelers.",
  statePageRoute: "/states/north-carolina",
  statePageName: "North Carolina",
  dmvWebsite: "https://www.ncdot.gov",
  dmvLabel: "North Carolina DMV — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Predictable turnaround",
        "Ideal for upcoming trips",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Faster than self-service",
        "Good for planned travel",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: [
        "No courier access — standard mail only",
        "Workload & wait times shift with shutdowns",
        "In-person clerk appointment required",
        "No document review — errors cause rejection",
        "No dedicated agent — you are on your own",
        "Updates only by physical mail letter",
        "No phone or email contact for your case",
        "Can't upgrade speed after submission",
        "Not suitable if travel is within 10 weeks",
      ],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: [
        "Appointment required — no walk-ins allowed",
        "Life-or-death emergencies only",
        "Bereavement or medical crisis",
        "Expect to wait all day or return next day",
      ],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For travelers with immediate departure needs — as fast as 24 hours for urgent Holly Springs international flights.",
      bullets: ["24–48 hour turnaround available", "Registered courier hand-delivery", "Flight verification support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for adults with a passport issued within the last 15 years at age 16 or older.",
      bullets: ["No clerk visit required for most", "Mail-in or courier options", "Lost passport replacement available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport",
      description: "First-time passport application guidance with acceptance clerk appointment support.",
      bullets: ["Acceptance facility locator", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Passport replacement with DS-64 form guidance and police report documentation.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement options"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 with parental consent and acceptance clerk support.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change",
      description: "Passport correction and name change service after marriage, divorce, or legal changes.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
    { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
    { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
    { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
    { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
    { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  ],
  testimonials: [
    {
      name: "Rachel M.",
      location: "Holly Springs, NC",
      rating: 5,
      text: "My passport expired 3 days before our family cruise to the Caribbean. Fast Passport Center had my renewal ready in 26 hours. I never left Holly Springs. The team was absolutely amazing.",
      service: "Passport Renewal",
    },
    {
      name: "Paul D.",
      location: "Fuquay-Varina, NC",
      rating: 5,
      text: "Emergency passport for a business trip to Tokyo. Got it in 30 hours. Fast Passport Center handled everything — I didn't have to drive to DC or Philadelphia. Saved my career.",
      service: "Emergency Passport",
    },
    {
      name: "Jennifer H.",
      location: "Apex, NC",
      rating: 5,
      text: "First passport for my 11-year-old before our Europe trip. Fast Passport Center walked us through every document and had her passport in 4 days. So easy for southern Wake families.",
      service: "Child Passport",
    },
    {
      name: "Kevin S.",
      location: "Cary, NC",
      rating: 5,
      text: "Lost my passport 2 days before a conference in London. Fast Passport Center had a replacement in my hands in 33 hours. Their Research Triangle coverage is the best.",
      service: "Lost Passport",
    },
  ],
  facilities: [
    {
      id: "holly-springs-1",
      name: "Holly Springs Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "200 W Buffalo St",
      city: "Holly Springs",
      state: "NC",
      zip: "27540",
      phone: "(919) 552-4501",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Downtown Holly Springs",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Holly Springs facility. Appointments strongly recommended. Call ahead to confirm passport acceptance hours.",
      icon: "ri-mail-line",
    },
    {
      id: "holly-springs-2",
      name: "Apex Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "400 E Williams St",
      city: "Apex",
      state: "NC",
      zip: "27502",
      phone: "(919) 362-4501",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "8 miles north of Holly Springs",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Full-service facility for Apex and Holly Springs residents. Photo services nearby at CVS and Walgreens.",
      icon: "ri-mail-line",
    },
    {
      id: "holly-springs-3",
      name: "Fuquay-Varina Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "212 E Vance St",
      city: "Fuquay-Varina",
      state: "NC",
      zip: "27526",
      phone: "(919) 552-4501",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "10 miles south of Holly Springs",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves southern Wake County and Fuquay-Varina area. Less crowded than Raleigh. Appointment required.",
      icon: "ri-mail-line",
    },
    {
      id: "holly-springs-4",
      name: "Cary Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "315 N Academy St",
      city: "Cary",
      state: "NC",
      zip: "27513",
      phone: "(919) 467-4501",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "12 miles north of Holly Springs",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Major regional facility for Cary and Morrisville. Full passport services available.",
      icon: "ri-mail-line",
    },
    {
      id: "holly-springs-5",
      name: "Wake County Clerk of Court",
      type: "Court Clerk Passport Acceptance",
      address: "300 S Salisbury St",
      city: "Raleigh",
      state: "NC",
      zip: "27601",
      phone: "(919) 792-4000",
      hours: "Mon–Fri: 8:00 AM – 5:00 PM",
      distance: "18 miles northeast of Holly Springs, Courthouse",
      website: "https://www.wakegov.com/",
      websiteLabel: "Wake County Clerk",
      notes: "Accepts passport applications. Good alternative to post office with extended hours. Appointment recommended.",
      icon: "ri-government-line",
    },
    {
      id: "holly-springs-6",
      name: "Raleigh Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "414 E Holding Ave",
      city: "Raleigh",
      state: "NC",
      zip: "27610",
      phone: "(919) 755-4501",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "18 miles northeast of Holly Springs",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Major regional facility for Raleigh metro. Full passport services available.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, limited slots", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 4.5 hour drive to Washington DC", fpc: "No — ship from home or office" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Guaranteed Timing", agency: "No — subject to availability", fpc: "Yes — contractual turnaround times" },
  ],
  mistakes: [
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "Holly Springs photo shops often use generic sizes. Passport photos must be exactly 2×2 inches with a white or off-white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 reasons for rejection at Wake County acceptance facilities.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Wrong Payment Amount",
      description: "Fees change frequently. Many Holly Springs applicants show up with incorrect payment and have to reschedule their appointment.",
    },
    {
      icon: "ri-calendar-close-line",
      title: "No Proof of Travel",
      description: "Without flight confirmation or travel itinerary, the regional agency will turn you away for emergency appointments.",
    },
    {
      icon: "ri-parent-line",
      title: "Missing Parental Consent",
      description: "For minors, both parents must appear or submit notarized consent. This trips up many Wake County families at the clerk.",
    },
    {
      icon: "ri-time-line",
      title: "Waiting Too Long to Start",
      description: "Holly Springs travelers often assume standard processing will be fine. It takes 8–11 weeks. Start expedited at least 3 weeks before travel.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS location in Holly Springs." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy before hand-delivering to the State Department." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Your passport is processed at a U.S. Department of State facility using our registered courier slots." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Holly Springs address — trackable every step of the way." },
  ],
  faqs: [
    { q: "Can I get an emergency passport in Holly Springs before international travel?", a: "Yes. Fast Passport Center provides emergency passport services in Holly Springs for travelers with urgent international flights. Our registered couriers hand-deliver your documents directly to U.S. Department of State facilities, achieving 24–48 hour turnaround — without the long drive to Washington DC." },
    { q: "How fast can I renew my passport in Holly Springs?", a: "Fast Passport Center offers fast passport renewal in Holly Springs in as little as 24–48 hours through our emergency courier service. For less urgent travel, our 3–5 day expedited option provides the best value. Both options include full document review and a dedicated agent." },
    { q: "What is the closest passport agency to Holly Springs?", a: "The nearest regional passport agency to Holly Springs is the Washington DC Passport Agency at 600 19th St NW, Washington DC 20006, approximately 280 miles north via I-95. For urgent processing without the long drive, Fast Passport Center's registered courier service achieves 24–48 hour turnaround from Holly Springs without any in-person agency visit required." },
    { q: "Can I get a same-day passport appointment near Holly Springs?", a: "Same-day passport appointments are only available at the Washington DC Passport Agency — approximately 4.5 hours from Holly Springs — for documented life-or-death emergencies. For all other urgent travel, Fast Passport Center's 24–48 hour emergency courier processing is the fastest guaranteed option for Wake County and southern Research Triangle residents." },
    { q: "Do you serve the entire southern Research Triangle area?", a: "Absolutely. Fast Passport Center serves the entire southern Research Triangle metropolitan area including Holly Springs, Apex, Cary, Fuquay-Varina, Raleigh, Durham, Morrisville, Chapel Hill, Garner, Wake Forest, Knightdale, Zebulon, Wendell, Angier, Clayton, Smithfield, Lillington, Sanford, Fayetteville, and Wilson. Our courier service works seamlessly from any address in Wake County, Johnston County, and surrounding areas." },
    { q: "Can I expedite a child passport in Holly Springs?", a: "Yes. Fast Passport Center expedites child passports in Holly Springs for minors under 16. Both parents must appear or submit notarized consent, along with the child's birth certificate and both parents' IDs. We walk Wake County families through the entire process." },
    { q: "What should I do if I lost my passport before a trip?", a: "If you lost your passport before a trip, contact Fast Passport Center immediately. We provide lost passport replacement services in Holly Springs with DS-64 form guidance and identity verification support. Our emergency courier service can get your replacement passport in 24–48 hours." },
    { q: "Do I need to drive to the Washington DC Passport Agency?", a: "No. With Fast Passport Center, you complete everything online and ship your documents overnight. Our couriers handle the in-person delivery to State Department facilities. You only need to visit a local acceptance clerk if you're a first-time applicant or need a name change." },
  ],
  photoLocations: [
    { name: "CVS Pharmacy — Holly Springs", address: "3200 N Main St, Holly Springs, NC 27540", hours: "Mon–Sun: 8AM–10PM", website: "https://www.cvs.com/" },
    { name: "Walgreens — Holly Springs", address: "1401 E Broad St, Holly Springs, NC 27540", hours: "Mon–Sun: 7AM–11PM", website: "https://www.walgreens.com/" },
    { name: "Walmart Supercenter — Holly Springs", address: "7010 GB Alford Hwy, Holly Springs, NC 27540", hours: "Mon–Sun: 6AM–11PM", website: "https://www.walmart.com/" },
    { name: "CVS Pharmacy — Apex", address: "960 US-64, Apex, NC 27523", hours: "Mon–Sun: 8AM–10PM", website: "https://www.cvs.com/" },
    { name: "Walgreens — Fuquay-Varina", address: "1401 E Broad St, Fuquay-Varina, NC 27526", hours: "Mon–Sun: 7AM–11PM", website: "https://www.walgreens.com/" },
    { name: "CVS Pharmacy — Cary", address: "1010 SE Cary Pkwy, Cary, NC 27518", hours: "Mon–Sun: 8AM–10PM", website: "https://www.cvs.com/" },
    { name: "Walgreens — Raleigh", address: "3600 New Bern Ave, Raleigh, NC 27610", hours: "Mon–Sun: 7AM–11PM", website: "https://www.walgreens.com/" },
    { name: "FedEx Office — Raleigh", address: "435 S Salisbury St, Raleigh, NC 27601", hours: "Mon–Fri: 7AM–9PM, Sat: 8AM–6PM", website: "https://www.fedex.com/" },
  ],
  dmvLocations: [
    {
      name: "NC DMV — Holly Springs",
      address: "7010 GB Alford Hwy, Holly Springs, NC 27540",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Driver's license and REAL ID services. Appointment recommended.",
      featured: true,
    },
    {
      name: "NC DMV — Apex",
      address: "39 Jones Cir, Apex, NC 27539",
      hours: "Mon–Fri: 8AM–5PM",
      note: "REAL ID and passport-related ID services. Appointment strongly recommended.",
      featured: false,
    },
    {
      name: "NC DMV — Raleigh",
      address: "3231 Avent Ferry Rd, Raleigh, NC 27606",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Serves Raleigh and western Wake County. REAL ID available.",
      featured: true,
    },
    {
      name: "NC DMV — Fuquay-Varina",
      address: "1301 E Broad St, Fuquay-Varina, NC 27526",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Serves southern Wake County and Fuquay-Varina area. REAL ID available.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "RDU",
      name: "Raleigh-Durham International Airport",
      distance: "18 miles northeast of Holly Springs",
      address: "2400 John Brantley Blvd, Morrisville, NC 27560",
      note: "Major international airport for the Research Triangle. Direct flights to London, Paris, Cancun, Toronto, and major domestic destinations. American, Delta, and United hub. Only 25 minutes from Holly Springs.",
      flightUrl: "https://www.rdu.com/",
      flightLabel: "RDU Airport",
      featured: true,
    },
    {
      code: "CLT",
      name: "Charlotte Douglas International Airport",
      distance: "160 miles southwest of Holly Springs",
      address: "5501 Josh Birmingham Pkwy, Charlotte, NC 28208",
      note: "Major alternative hub for the Charlotte metro area. Additional international routes.",
      flightUrl: "https://www.cltairport.com/",
      flightLabel: "CLT Airport",
      featured: false,
    },
    {
      code: "GSO",
      name: "Piedmont Triad International Airport",
      distance: "70 miles west of Holly Springs",
      address: "1000 Ted Johnson Pkwy, Greensboro, NC 27409",
      note: "Alternative airport for North Carolina residents. Additional domestic routes.",
      flightUrl: "https://www.flyfrompti.com/",
      flightLabel: "GSO Airport",
      featured: false,
    },
  ],
  vitalRecordsLinks: [
    {
      label: 'North Carolina Vital Records (NCDHHS)',
      description: 'Birth and death certificates for all NC counties. Order online, by mail, or in person at the Raleigh office.',
      url: 'https://vitalrecords.nc.gov/',
    },
    {
      label: 'Wake County Register of Deeds',
      description: 'Marriage licenses and records for Wake County. Apply in person or request certified copies.',
      url: 'https://www.wake.gov/departments-government/register-deeds',
    },
    {
      label: 'Wake County Clerk of Superior Court',
      description: 'Divorce records and decrees for Wake County. Contact the clerk for certified copies.',
      url: 'https://www.nccourts.gov/locations/wake-county/wake-county-clerk-of-superior-court',
    },
  ],
  landmarks: [
    {
      name: "Raleigh-Durham International Airport (RDU)",
      icon: "ri-flight-takeoff-line",
      distance: "~18 miles northeast of Holly Springs",
      desc: "Major international hub serving 14M+ passengers annually with nonstop flights to London, Paris, Cancun, Toronto, and 60+ domestic destinations. The closest international airport for southern Wake County — a 25-minute drive via NC-540.",
      url: "https://www.rdu.com/",
      schemaType: "Airport",
    },
    {
      name: "Holly Springs Cultural Center",
      icon: "ri-building-2-line",
      distance: "Downtown Holly Springs — 300 W Ballentine St",
      desc: "A 19,500 sq ft community arts hub featuring a 200-seat theater, art gallery, dance studio, and meeting spaces. Hosts performances, film screenings, art exhibitions, and community events that anchor Holly Springs' cultural identity.",
      url: "https://www.hollyspringsnc.gov/",
      schemaType: "TouristAttraction",
    },
    {
      name: "Bass Lake Park & Retreat",
      icon: "ri-leaf-line",
      distance: "East Holly Springs — 900 Bass Lake Rd",
      desc: "185-acre park centered on a 55-acre lake with a 2-mile paved trail, fishing pier, picnic shelters, boardwalks, and the newly renovated retreat center. A premier outdoor destination for southern Wake County families and one of the region's most popular parks.",
      url: "https://www.hollyspringsnc.gov/",
      schemaType: "TouristAttraction",
    },
    {
      name: "Ting Park",
      icon: "ri-football-line",
      distance: "Central Holly Springs — 1151 N Main St",
      desc: "Multi-sport complex featuring a 1,800-seat baseball stadium (home of the Coastal Plain League's Salamanders), tennis courts, soccer fields, and a community center. A major regional sports and events destination drawing teams and spectators from across the Triangle.",
      url: "https://www.hollyspringsnc.gov/",
      schemaType: "TouristAttraction",
    },
    {
      name: "Sugg Farm Park",
      icon: "ri-walk-line",
      distance: "North Holly Springs — 2401 Grigsby Ave",
      desc: "A 103-acre passive park with scenic walking trails, open meadows, a pond, and preserved historic farm structures. The park hosts the annual HollyFest community celebration and provides green space for one of North Carolina's fastest-growing towns.",
      url: "https://www.hollyspringsnc.gov/",
      schemaType: "TouristAttraction",
    },
    {
      name: "Devil's Ridge Golf Club",
      icon: "ri-golf-ball-line",
      distance: "North Holly Springs — 5107 Linksland Dr",
      desc: "A championship 18-hole John LaFoy-designed golf course winding through rolling piedmont terrain with dramatic elevation changes and lake views. A premier Triangle golf destination drawing players from across Wake County.",
      url: "https://www.devilsridge.com/",
      schemaType: "TouristAttraction",
    },
    {
      name: "Holly Springs Towne Center",
      icon: "ri-shopping-bag-line",
      distance: "NC-55 at New Hill Rd, Central Holly Springs",
      desc: "A major retail and dining destination for southern Wake County spanning 400,000+ sq ft with national anchors, specialty shops, restaurants, and a cinema. Serves Holly Springs, Fuquay-Varina, and the rapidly growing NC-55 corridor.",
      url: "https://www.hollyspringstownecenter.com/",
      schemaType: "TouristAttraction",
    },
    {
      name: "NC-55 / US-1 / NC-540 Transportation Corridor",
      icon: "ri-road-map-line",
      distance: "Major transportation corridors through the Holly Springs metro",
      desc: "NC-55 runs north-south through downtown Holly Springs connecting to Apex, Durham, and RTP. NC-540 (Triangle Expressway) provides quick access to RDU, Cary, and Morrisville. US-1 connects to Sanford, Southern Pines, and the Sandhills. These corridors define Holly Springs' strategic position in the booming southern Wake County growth corridor.",
      url: "https://www.ncdot.gov/",
      schemaType: "CivicStructure",
    },
  ],
  areaServedList: [
    { "@type": "City", name: "Holly Springs" },
    { "@type": "City", name: "Apex" },
    { "@type": "City", name: "Cary" },
    { "@type": "City", name: "Fuquay-Varina" },
    { "@type": "City", name: "Raleigh" },
    { "@type": "City", name: "Durham" },
    { "@type": "City", name: "Morrisville" },
    { "@type": "City", name: "Garner" },
    { "@type": "City", name: "Clayton" },
    { "@type": "City", name: "Angier" },
    { "@type": "AdministrativeArea", name: "Wake County" },
    { "@type": "AdministrativeArea", name: "Johnston County" },
  ],
  serviceAreaDesc: "Fast Passport Center serves Holly Springs via secure registered courier — emergency and expedited passport services as fast as 24 hours for Holly Springs, Fuquay-Varina, Apex, Cary, and all southern Wake County communities. A+ BBB rated.",
};